import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateIvrMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  recordingType?: Types.InputMaybe<Types.DirectionType>;
  nonPaymentBlockingType?: Types.InputMaybe<Types.NonPaymentBlockingType>;
  outgoingCallBarringAdmin?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  callLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  privateCallerAnnouncement?: Types.InputMaybe<Types.UpdateIvrAnnouncement>;
}>;


export type UpdateIvrMutation = { __typename?: 'Mutation', updateIvr?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type IvrLimitQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type IvrLimitQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', ccAattendant: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null } } } };

export type IvrCallsQueryVariables = Types.Exact<{
  numberId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filterValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
  recordingId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type IvrCallsQuery = { __typename?: 'Query', callList: { __typename?: 'CallList', calls: Array<{ __typename?: 'Call', callId: string, callTime: any, connectTime: any, disconnectTime: any, remoteNumber: string, remoteNumberId?: number | null, localNumber: string, recordingId?: string | null, connected: boolean, recordingStore?: Types.RecordingStore | null, direction: string }> } };

export type IvrNumberIdQueryVariables = Types.Exact<{
  ivrId: Types.Scalars['Int']['input'];
}>;


export type IvrNumberIdQuery = { __typename?: 'Query', ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', number?: { __typename?: 'Number', id: number, domain: { __typename?: 'Domain', name: string } } | null } | null> } | null };


export const UpdateIvrDocument = gql`
    mutation UpdateIvr($id: Int!, $name: String, $recordingType: DirectionType, $nonPaymentBlockingType: NonPaymentBlockingType, $outgoingCallBarringAdmin: [OutgoingCallBarring], $outgoingCallBarringOperator: [OutgoingCallBarring], $callLimit: Int, $privateCallerAnnouncement: UpdateIvrAnnouncement) {
  updateIvr(
    id: $id
    name: $name
    recordingType: $recordingType
    nonPaymentBlockingType: $nonPaymentBlockingType
    outgoingCallBarringAdmin: $outgoingCallBarringAdmin
    outgoingCallBarringOperator: $outgoingCallBarringOperator
    callLimit: $callLimit
    privateCallerAnnouncement: $privateCallerAnnouncement
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateIvrMutationFn = Apollo.MutationFunction<UpdateIvrMutation, UpdateIvrMutationVariables>;

/**
 * __useUpdateIvrMutation__
 *
 * To run a mutation, you first call `useUpdateIvrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIvrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIvrMutation, { data, loading, error }] = useUpdateIvrMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      recordingType: // value for 'recordingType'
 *      nonPaymentBlockingType: // value for 'nonPaymentBlockingType'
 *      outgoingCallBarringAdmin: // value for 'outgoingCallBarringAdmin'
 *      outgoingCallBarringOperator: // value for 'outgoingCallBarringOperator'
 *      callLimit: // value for 'callLimit'
 *      privateCallerAnnouncement: // value for 'privateCallerAnnouncement'
 *   },
 * });
 */
export function useUpdateIvrMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIvrMutation, UpdateIvrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIvrMutation, UpdateIvrMutationVariables>(UpdateIvrDocument, options);
      }
export type UpdateIvrMutationHookResult = ReturnType<typeof useUpdateIvrMutation>;
export type UpdateIvrMutationResult = Apollo.MutationResult<UpdateIvrMutation>;
export type UpdateIvrMutationOptions = Apollo.BaseMutationOptions<UpdateIvrMutation, UpdateIvrMutationVariables>;
export const IvrLimitDocument = gql`
    query IvrLimit($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      ccAattendant {
        domainAllocated
        domainUsed
        remaining
        allocationIncrementError {
          type
          context
        }
      }
    }
  }
}
    `;

/**
 * __useIvrLimitQuery__
 *
 * To run a query within a React component, call `useIvrLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrLimitQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useIvrLimitQuery(baseOptions: Apollo.QueryHookOptions<IvrLimitQuery, IvrLimitQueryVariables> & ({ variables: IvrLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrLimitQuery, IvrLimitQueryVariables>(IvrLimitDocument, options);
      }
export function useIvrLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrLimitQuery, IvrLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrLimitQuery, IvrLimitQueryVariables>(IvrLimitDocument, options);
        }
export function useIvrLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrLimitQuery, IvrLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrLimitQuery, IvrLimitQueryVariables>(IvrLimitDocument, options);
        }
export type IvrLimitQueryHookResult = ReturnType<typeof useIvrLimitQuery>;
export type IvrLimitLazyQueryHookResult = ReturnType<typeof useIvrLimitLazyQuery>;
export type IvrLimitSuspenseQueryHookResult = ReturnType<typeof useIvrLimitSuspenseQuery>;
export type IvrLimitQueryResult = Apollo.QueryResult<IvrLimitQuery, IvrLimitQueryVariables>;
export const IvrCallsDocument = gql`
    query IvrCalls($numberId: Int, $domainId: Int, $filterValue: String, $recordingId: String) {
  callList(
    numberId: $numberId
    domainId: $domainId
    filterValue: $filterValue
    recordingIdFilter: $recordingId
  ) {
    calls {
      callId
      callTime
      connectTime
      disconnectTime
      remoteNumber
      remoteNumberId
      localNumber
      recordingId
      connected
      recordingStore
      direction
    }
  }
}
    `;

/**
 * __useIvrCallsQuery__
 *
 * To run a query within a React component, call `useIvrCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrCallsQuery({
 *   variables: {
 *      numberId: // value for 'numberId'
 *      domainId: // value for 'domainId'
 *      filterValue: // value for 'filterValue'
 *      recordingId: // value for 'recordingId'
 *   },
 * });
 */
export function useIvrCallsQuery(baseOptions?: Apollo.QueryHookOptions<IvrCallsQuery, IvrCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrCallsQuery, IvrCallsQueryVariables>(IvrCallsDocument, options);
      }
export function useIvrCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrCallsQuery, IvrCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrCallsQuery, IvrCallsQueryVariables>(IvrCallsDocument, options);
        }
export function useIvrCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrCallsQuery, IvrCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrCallsQuery, IvrCallsQueryVariables>(IvrCallsDocument, options);
        }
export type IvrCallsQueryHookResult = ReturnType<typeof useIvrCallsQuery>;
export type IvrCallsLazyQueryHookResult = ReturnType<typeof useIvrCallsLazyQuery>;
export type IvrCallsSuspenseQueryHookResult = ReturnType<typeof useIvrCallsSuspenseQuery>;
export type IvrCallsQueryResult = Apollo.QueryResult<IvrCallsQuery, IvrCallsQueryVariables>;
export const IvrNumberIdDocument = gql`
    query IvrNumberId($ivrId: Int!) {
  ivrs(id: $ivrId) {
    items {
      number {
        id
        domain {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useIvrNumberIdQuery__
 *
 * To run a query within a React component, call `useIvrNumberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrNumberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrNumberIdQuery({
 *   variables: {
 *      ivrId: // value for 'ivrId'
 *   },
 * });
 */
export function useIvrNumberIdQuery(baseOptions: Apollo.QueryHookOptions<IvrNumberIdQuery, IvrNumberIdQueryVariables> & ({ variables: IvrNumberIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrNumberIdQuery, IvrNumberIdQueryVariables>(IvrNumberIdDocument, options);
      }
export function useIvrNumberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrNumberIdQuery, IvrNumberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrNumberIdQuery, IvrNumberIdQueryVariables>(IvrNumberIdDocument, options);
        }
export function useIvrNumberIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrNumberIdQuery, IvrNumberIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrNumberIdQuery, IvrNumberIdQueryVariables>(IvrNumberIdDocument, options);
        }
export type IvrNumberIdQueryHookResult = ReturnType<typeof useIvrNumberIdQuery>;
export type IvrNumberIdLazyQueryHookResult = ReturnType<typeof useIvrNumberIdLazyQuery>;
export type IvrNumberIdSuspenseQueryHookResult = ReturnType<typeof useIvrNumberIdSuspenseQuery>;
export type IvrNumberIdQueryResult = Apollo.QueryResult<IvrNumberIdQuery, IvrNumberIdQueryVariables>;